import { CheckEmail } from '@features/Unsubscribe/steps/CheckEmail';
import { DiscountActivated } from '@features/Unsubscribe/steps/DiscountActivated';
import { EmailEnter } from '@features/Unsubscribe/steps/EmailEnter';
import { Error } from '@features/Unsubscribe/steps/Error';
import { Feedback } from '@features/Unsubscribe/steps/Feedback';
import { Freezed } from '@features/Unsubscribe/steps/Freezed';
import { GiftPremium } from '@features/Unsubscribe/steps/GiftPremium';
import { Happy } from '@features/Unsubscribe/steps/Happy';
import { KeepInMind } from '@features/Unsubscribe/steps/KeepInMind';
import { KeepPremium } from '@features/Unsubscribe/steps/KeepPremium';
import { LifetimeAccess } from '@features/Unsubscribe/steps/LifetimeAccess';
import { LifetimeActivated } from '@features/Unsubscribe/steps/LifetimeActivated';
import { LotsOfNew } from '@features/Unsubscribe/steps/LotsOfNew';
import { PremiumActivated } from '@features/Unsubscribe/steps/PremiumActivated';
import { ReasonStep } from '@features/Unsubscribe/steps/ReasonStep';
import { Sad } from '@features/Unsubscribe/steps/Sad';
import { SpecialDiscount } from '@features/Unsubscribe/steps/SpecialDiscount';
import { SpecialOffer } from '@features/Unsubscribe/steps/SpecialOffer';
import { ToPause } from '@features/Unsubscribe/steps/ToPause';
import type { TpWizardSteps, TpWizardValues } from '@features/Unsubscribe/types';
import { WIZARD_STEPS } from '@features/Unsubscribe/сonstants';
export const WizardSteps = (props: TpWizardSteps): JSX.Element => {
  const stepComponents: Record<TpWizardValues, JSX.Element> = {
    [WIZARD_STEPS.ERROR]: <Error {...props} />,
    [WIZARD_STEPS.FEEDBACK]: <Feedback {...props} />,
    [WIZARD_STEPS.FREEZED]: <Freezed {...props} />,
    [WIZARD_STEPS.REASON]: <ReasonStep {...props} />,
    [WIZARD_STEPS.TO_PAUSE]: <ToPause {...props} />,
    [WIZARD_STEPS.HAPPY]: <Happy {...props} />,
    [WIZARD_STEPS.SAD]: <Sad {...props} />,
    [WIZARD_STEPS.SPECIAL_OFFER]: <SpecialOffer {...props} />,
    [WIZARD_STEPS.KEEP_IN_MIND]: <KeepInMind {...props} />,
    [WIZARD_STEPS.EMAIL_ENTER]: <EmailEnter {...props} />,
    [WIZARD_STEPS.EMAIL_SENT]: <CheckEmail {...props} />,
    //New cancellation steps
    [WIZARD_STEPS.LOTS_OF_NEW]: <LotsOfNew {...props} />,
    [WIZARD_STEPS.KEEP_PREMIUM]: <KeepPremium {...props} />,
    [WIZARD_STEPS.GIFT_PREMIUM]: <GiftPremium {...props} />,
    [WIZARD_STEPS.PREMIUM_ACTIVATED]: <PremiumActivated />,
    [WIZARD_STEPS.LIFETIME_ACCESS]: <LifetimeAccess {...props} />,
    [WIZARD_STEPS.LIFETIME_ACTIVATED]: <LifetimeActivated {...props} />,
    [WIZARD_STEPS.SPECIAL_DISCOUNT]: <SpecialDiscount {...props} />,
    [WIZARD_STEPS.DISCOUNT_ACTIVATED]: <DiscountActivated />
  };
  return stepComponents[props.step] || <div>Step Does Not Exist</div>;
};